<svg class="logo logo--login" viewBox="0 0 111 39.96">
  <use xlink:href="#ab-logo"></use>
</svg>

<form #signInForm="ngForm" id="signInForm" class="form form--login" (ngSubmit)="login()" (click)="userInteracted = true" method="post">
  <div class="notif notif--small notif--green vert-0050" *ngIf="successMessage" data-test-id="successNotif">
      {{successMessage }}
  </div>
  <app-error-notification [errors]="errorMessages"></app-error-notification>

  <div class="mb-0150 auth-card mat-card--simple mat-card--border">
    <h1 class="sr-only">Login</h1>

    <div class="auth-card__content">
      <mat-form-field [hideRequiredMarker]="true" class="col__ ongray form__uname mb-0100">
          <mat-label>Username</mat-label>
          <input matInput id="email" name="email" placeholder="Email Address" required type="email"
              #usernameInput
              [(ngModel)]="email"
              (keyup)="userInteracted = true"
              appAutofocus>
      </mat-form-field>

      <mat-form-field [hideRequiredMarker]="true" class="col__ ongray form__pword mb-0">
          <mat-label>Password</mat-label>
          <input matInput id="password" name="password" required [type]="pwShown ? 'text' : 'password'" [(ngModel)]="password"
          (keyup)="userInteracted = true"
          #passwordInput
          />
          <span matSuffix mat-icon-button aria-label="Show" [ngStyle]="{'color': pwShown ? '#006EC5' : '#C3C9D9'}"
              (click)="pwShown = !pwShown">
              <mat-icon fontSet="far" fontIcon="fa-eye"></mat-icon>
          </span>
      </mat-form-field>

      <p class="align--right vert-0050 mb-0">
        <a routerLink="/forgot_password" class="link link--small">Forgot your password?</a>
      </p>
    </div>
  </div>

  <div class="mb-0100">
    <button type="submit" id="loginButton" class="btn btn--full btn--lg btn--submit" [disabled]="isSubmitting || (userInteracted && signInForm.invalid)">
      <span *ngIf="!isSubmitting">Login</span>
      <span *ngIf="isSubmitting">Logging in...</span>
    </button>
  </div>
</form>
